import React from 'react'
import FAQ from './components/FAQ';
import Features from './components/Features'
import Hero from './components/Hero'
import SupportUs from './components/SupportUs';
import './index.scss';
const WebPage = (props : {darkMode: boolean}) => {
    


    return (
        <>
        <Hero darkMode={props.darkMode}/>
        <Features/>
        <FAQ/>
        <SupportUs/>
        </>

       

    )
}

export default WebPage